export class LoginLogoutAction {
    constructor(userRepository) {
      this.userRepository = userRepository;
    }
  
    async execute(action) {
      return await this.userRepository.LoginLogoutAction(action);
    }
  }